import { STTOK_LOGO } from 'constants/defaultConstants';

export const LOGIN_SLIDER_INTERVAL_MS = 4000;

export const LOGIN_SLIDER_DESKTOP_FADE_MS = 180;

export const LOGIN_SLIDER_MOBILE_FADE_MS = 300;

export const LOGIN_SLIDER_LOGO_DARK = STTOK_LOGO;

export const LOGIN_SLIDER_LOGO_LIGHT = STTOK_LOGO;
